export default __webpack_public_path__ + "static/media/README.e3b0c442.md";